export default "__VITE_ASSET__17V5ANWW__"